/*
    Simple message relay to send arbitrary messages between Vue apps.
    Intended receiver is the headerApp.

    Note: Since this is being migrated to a SPA and we do not need to communicate this way between Apps,
    it may be other solutions that we can use, kept as is to avoid scope creep.
*/
export default function() {
    const receivers: Record<string, () => Promise<void>> = {};
    return {
        on(messageName: string, receiverFunction: () => Promise<void>): void {
            receivers[messageName] = receiverFunction;
        },
        async send(messageName: string): Promise<void> {
            if (receivers[messageName]) {
                await receivers[messageName]();
            }
        }
    };
}

export interface HeaderMailbox {
    on(messageName: string, receiverFunction: () => Promise<void>): void;
    send(messageName: string): Promise<void>;
}
